<template>
  <header class="header" ref="Header">
    <Progress v-show="$store.state.progress" />
    <main>
      <div class="top_header">
        <a-row>
          <a-col style="position: relative;display: flex;align-items: center;" :span="6"><img @click="$router.$push('/home')" :src="require('@/assets/images/logo/logo.png')">
          <!-- 这里写项目名称 -->
          <div class="project-name">
            <p>{{ t('header.platformName') }}</p>
          </div>
          </a-col>
          <a-col class="right_breadcrumb" :span="18">
            <AntBreadcrumb :data="data" separator="|" :select="select" @click="submit" />
            <div class="header_user">
              <User />
            </div>
          </a-col>
        </a-row>
      </div>
      <Navigation />
    </main>
  </header>
</template>

<script>
import User from './user';
import Navigation from './navigation';
import Progress from './progress';
import { switchSiteLanguage } from '@/utils/niuTrans';
import { t } from '@/locales';

export default {
  components: { User, Navigation, Progress },
  data() {
    return {
      data: [],
      select: "chinese",
      langSwitching: false
    }
  },
  watch: {
    '$route': {
      deep: true,
      handler: function () {
        this.getRouter();
      }
    },
    '$store.state.language'() {
      this.setData();
    }
  },
  created() {
    this.setData();
    this.getRouter();
  },
  methods: {
    t,
    submit(item = {}) {
      const { value = null, router = null, mode } = item;
      if (value === 'chinese' || value === 'english') {
        this.onLanguageClick(value);
        return;
      }
      if (mode) {
        this.$FN.limitsTips({ list: mode, key: "some" }).then(res => res && router && this.$router.$push(router));
      } else {
        this.select = value;
        router && this.$router.$push(router);
      }
    },
    async onLanguageClick(lang) {
      if (this.langSwitching) return;
      // 中文版重复点击忽略；英文版允许重复点击以强制重新翻译
      if (lang === 'chinese' && this.$store.state.language === 'chinese') return;
      this.langSwitching = true;
      try {
        await switchSiteLanguage(lang, { store: this.$store, force: lang === 'english' });
        this.setData();
      } finally {
        this.langSwitching = false;
      }
    },
    getRouter() {
      this.select = this.$route.path;
    },
    setData() {
      const language = this.$store.state.language || 'chinese';
      let list = [
        {
          labelKey: 'header.message',
          label: t('header.message'),
          value: "/message",
          router: "/message",
          rolesKey: "messagecenter",
          mode: ["messagecenter_skip"],
          icon: "icon-wjjf_icon_line_xiaoxi",
        },
        {
          labelKey: 'header.feedback',
          label: t('header.feedback'),
          value: "/feedback",
          router: "/feedback",
          rolesKey: "demand_feedback",
          mode: ["demand_feedback_skip"],
          activeStyle: { color: '#0068B7' }
        },
        {
          labelKey: 'header.zh',
          label: t('header.zh'),
          value: "chinese",
          niuSkip: true,
          langSwitch: true,
          style: language === 'chinese' ? { color: '#ae2024' } : { color: '#333333' }
        },
        {
          labelKey: 'header.en',
          label: t('header.en'),
          value: "english",
          niuSkip: true,
          langSwitch: true,
          style: language === 'english' ? { color: '#ae2024' } : { color: '#333333' }
        }
      ];
      this.data = this.$FN.filterLimitsVisible({ data: list });
    }
  }
}
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>
